import type { ICellRendererParams } from 'ag-grid-enterprise';
import type React from 'react';
import type { ProjectLogEntry } from '../../services/timeEntryService';

export const TaskCellRenderer: React.FC<ICellRendererParams<ProjectLogEntry>> = (params) => {
  const task = params.data?.task_info;
  const billable = params.data?.billable;

  if (!task) return null;

  const billableStatus = billable ? 'Billable' : 'Non-Billable';
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.5' }}>
      <div>{`${task.task_code}_${task.task_name}`}</div>
      <div style={{ fontSize: '0.875rem', color: '#64748b' }}>{billableStatus}</div>
    </div>
  );
};

